<template>
  <button v-if="isAuthorized" class="menu-favourite" @click="handlerOpenModal">
    <svg class="menu-favourite__icon">
      <use xlink:href="#svg-favourite"></use>
    </svg>
    {{ messages.title }}
  </button>

  <button v-else type="button" class="menu-favourite" @click="handlerClick">
    <svg class="menu-favourite__icon">
      <use xlink:href="#svg-favourite"></use>
    </svg>
    {{ messages.title }}
  </button>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import useModal from '@use/useModal/useModal';
import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';
import { useStore } from '@/store';
import useFavouriteState from '@use/useFavouriteState';

const { state, commit } = useStore();

const { result } = defineProps(['result']);
const modal = useModal();
const favouriteState = useFavouriteState();

const isAuthorized = computed(() => state.personal.data.authInfo.isAuthorized);
const messages = computed(() => state.favourite.data.messages);
const listPage = computed(() => state.favourite.data?.routes?.listPage);

const handlerClick = () => {
  modal.show(SignIn, {}, { width: '900px', backgroundClose: false });
};

const handlerOpenModal = () => {
  favouriteState.open();
};
</script>

<script>
export default {
  name: 'MenuFavourite',
};
</script>

<style lang="scss" scoped>
.menu-favourite {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  padding-right: 6px;
  font-size: 16px;
  &_active {
    position: relative;
    background-color: var(--background-beige);
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -16px;
      bottom: 0;
      width: 16px;
      background-color: var(--background-beige);
    }
  }
  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    fill: var(--background-black);
  }
}
</style>
